import { NCDialect } from '@components/ncFileVersions/components/NCFileDiffView/types';

export enum ChangeSummaryCategory {
  TOOL = 'tool',
  M_CODE = 'mCode',
  FEED_RATE = 'feedRate',
  SPINDLE_SPEED = 'spindleSpeed',
  RADIUS_COMP = 'radiusComp',
  COORDINATE = 'coordinate',
  POLAR = 'polar',
  CYCLE_CODE = 'cycleCode',
  PARAMETER = 'parameter',
  COMMENT = 'comment',
}

export const MAX_LISTED_PER_CATEGORY = 50;
export const COMMENT_LABEL_MAX_LENGTH = 60;

export const COORDINATE_DELTA_PRECISION = 4;

export const COMMENT_PATTERN = /\([^()]*\)|;[^\r\n]*/g;
export const COORDINATE_TOKEN_REGEX = /^([XYZ])([+\-]?\d+(?:\.\d+)?)$/;

export interface CategoryDescriptor {
  category: ChangeSummaryCategory;
  pattern: RegExp;
}

// Dialect-aware classifier inputs. Klartext (.H) uses descriptive letter codes
// (L/C/RL/RR/CYCL DEF/Q…); ISO (.I/.NC) uses G-code numerics (G01/G41/G81/#…).
// M-codes and S/F/comments overlap. Both alphabets are reported as raw token
// diffs (e.g. "M03 → M05") — no glossary translation.
export const CATEGORY_DESCRIPTORS_BY_DIALECT: Record<NCDialect, CategoryDescriptor[]> = {
  klartext: [
    { category: ChangeSummaryCategory.TOOL, pattern: /TOOL CALL\s+\d+/g },
    { category: ChangeSummaryCategory.M_CODE, pattern: /\bM\d+\b/g },
    { category: ChangeSummaryCategory.FEED_RATE, pattern: /\bF(?:MAX|\d+(?:\.\d+)?)\b/g },
    { category: ChangeSummaryCategory.SPINDLE_SPEED, pattern: /\bS\d+(?:\.\d+)?\b/g },
    { category: ChangeSummaryCategory.RADIUS_COMP, pattern: /\b(?:RL|RR|R0)\b/g },
    { category: ChangeSummaryCategory.CYCLE_CODE, pattern: /CYCL DEF\s+\d+/g },
    { category: ChangeSummaryCategory.POLAR, pattern: /\b(?:CC|LP|CP)\b/g },
    { category: ChangeSummaryCategory.COORDINATE, pattern: /[XYZ][+\-]?\d+(?:\.\d+)?/g },
    { category: ChangeSummaryCategory.PARAMETER, pattern: /Q\d+\s*=\s*[+\-]?\d+(?:\.\d+)?/g },
    { category: ChangeSummaryCategory.COMMENT, pattern: COMMENT_PATTERN },
  ],
  iso: [
    { category: ChangeSummaryCategory.TOOL, pattern: /\bT\d+\b/g },
    { category: ChangeSummaryCategory.M_CODE, pattern: /\bM\d+\b/g },
    { category: ChangeSummaryCategory.FEED_RATE, pattern: /\bF\d+(?:\.\d+)?\b/g },
    { category: ChangeSummaryCategory.SPINDLE_SPEED, pattern: /\bS\d+(?:\.\d+)?\b/g },
    { category: ChangeSummaryCategory.RADIUS_COMP, pattern: /\bG4[012]\b/g },
    { category: ChangeSummaryCategory.CYCLE_CODE, pattern: /\bG(?:8\d|200)\b/g },
    { category: ChangeSummaryCategory.COORDINATE, pattern: /[XYZ][+\-]?\d+(?:\.\d+)?/g },
    { category: ChangeSummaryCategory.PARAMETER, pattern: /#(?:\d+|<[^>]+>)\s*=\s*[+\-]?\d+(?:\.\d+)?/g },
    { category: ChangeSummaryCategory.COMMENT, pattern: COMMENT_PATTERN },
  ],
};
